/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getAppIconList: (params) => {
    return axios.get(API_ENDPOINTS.GET_APP_ICONS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getAppIconById: (id) => {
    return axios.get(API_ENDPOINTS.GET_APP_ICON_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addAppIcon: (data) => {
    return axios.post(API_ENDPOINTS.ADD_APP_ICON, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateAppIcon: (id, data) => {
    const url = API_ENDPOINTS.UPDATE_APP_ICON_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteAppIcon: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_APP_ICON_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
